<template>
    <b-modal size="md" hide-footer v-model="show" title="Edição da Configuração do Sistema" @hidden="cancelar">
        <b-card>
            <b-row>
                <b-col cols="12">
                    <div><span class="font-weight-bold">Configuração:</span> {{ configuracao.tituloPropriedade }}</div>
                </b-col>
            </b-row>
        </b-card>
        <b-form @submit.prevent="salvar">
            <b-form-group>
                <div v-for="(valor, index) in valores" :key="index">
                    <span class="font-weight-bold">{{ buscarLabel(index + 1) }} <b-form-checkbox class="ml-3"
                            v-model="valores[index]" :value="1" :unchecked-value="0" />
                    </span>
                </div>
            </b-form-group>
            <b-form-row class="d-flex justify-content-center">
                <b-button type="submit" size="sm" pill variant="success">
                    <b-icon icon="check-circle" />
                </b-button>
                <b-button size="sm" pill variant="danger" @click="cancelar" class="ml-2">
                    <b-icon icon="x-circle" />
                </b-button>
            </b-form-row>
        </b-form>
    </b-modal>
</template>

<script>
import ConfiguracaoSistemaService from "@/core/api/ConfiguracaoSistemaService";
import Swal from "sweetalert2";

export default {
    components: {
    },
    props: {
        configuracao: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            valores: [],
            show: true,
            form: {
                valor: "",
            },
        };
    },
    methods: {
        buscarLabel(indice) {

            switch (indice) {
                case 1:
                    return "Consumo Total";
                case 2:
                    return "N meses do C. M. M.";

                case 3:
                    return "C. M. M.";

                case 4:
                    return "Estoque Atual";

                case 5:
                    return "Estoque Residual";

                case 6:
                    return "Duração estoque atual(meses)";

                case 7:
                    return "Fator de segurança(%)";

                case 8:
                    return "Estoque Máximo";

                case 9:
                    return "Ponto de Ressuprimento(Estoque de Segurança)";

                case 10:
                    return "Prazo de Aquisição(meses)";

                case 11:
                    return "Intervalo de Aquisição(meses)";
                case 12:
                    return "Quantidade a ser adquirida";
            }

        },
        async salvar() {
            const payload = {
                id: this.configuracao.id,
                valorPropriedade: this.valores.join(';'),
            };

            try {
                await ConfiguracaoSistemaService.atualizarConfiguracao(payload);
                this.$emit("salvo");
                await Swal.fire({
                    title: "Sucesso",
                    text: "Configuração salva com sucesso!",
                    icon: "success",
                    confirmButtonText: "OK",
                });
            } catch (error) {
                this.$bvToast.toast("Erro ao salvar configuração", {
                    title: "Erro",
                    variant: "danger",
                    solid: true,
                });
            }
        },
        cancelar() {
            this.$emit("close");
        },
        carregarDadosIniciais() {
            this.valores = this.configuracao.valorPropriedade
                .split(';')
                .map(v => Number(v));

        },
    },
    beforeMount() {
        this.carregarDadosIniciais();
    },
};
</script>

<style scoped>
.font-weight-bold {
    font-weight: bold;
}
</style>
